export const CheckSpot = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="84"
    height="84"
    fill="none"
    viewBox="0 0 84 84"
  >
    <path fill="url(#pattern0_833_119086)" d="M0 0h84v84H0z"></path>
    <defs>
      <pattern
        id="pattern0_833_119086"
        width="1"
        height="1"
        patternContentUnits="objectBoundingBox"
      >
        <use xlinkHref="#image0_833_119086" transform="scale(.0119)"></use>
      </pattern>
      <image
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFQAAABUCAYAAAAcaxDBAAAEnklEQVR4Ae2dTW7TQBTHX6ACBAIK9AbcgBNwA1ZsOUCcoCLxzcZbOAGcoFLiFoEgAoGUBa3UBTvKBXqCcoKivy0746nHmZn4jZ36WapiO87MvF/ep9s+E9lvA5qNL9MsvkHzeJO+xbdpHm+dy59Mts1UVshMNLDHtOzKycOLtP/8+rkE56IQYBDHF5bhMr9/SgP6/vQa/Xx1p/cwc/Bg8Tu+SmDjtM3jDfry8paANLg0sIHlWm3z+IpopQFkrql4hbZm/rUGK6iLidsH2ozVhonogH6JmTu7OTCrzAIQgFSVln17TQW70oYgJKZuD1BXNrArBanDNFn3H1CfoI/HKHjSDcmqaOfqygSGqS9F6O+jRnHI/De+RPRJysrGFAos6ceLm40NyPGtr9OYYCm5p0VVZPulpjmpBKTVA1IOPA1M+YG8NgNW/GeDJg+lFKACtBnT5HJxoqGioaKhvbKCXgnL5TfVcc8l0Nmzu7Q7ekvJaJ92o/eEY1Vozv1gE3EKoY89Gf6haXRa/OD44/b9ILIGmUQXmPN4Gu0UIFWo0+iE9p48YJeXfQJOePrYyeM3BpgLbZ2OX7PKzDq4LjDnMbSvrJEKRMX8cU0SvWOTm21gTnj62PCPMGlboLiOK1CtPVCA0YOQDVgBaigRk+irk2amsIcHbIrENrBulhzHSfTBGeYk+keft++xyc02MAdAdczpaOwME9rJnY+uJdAsCJmjuNGHjsbs8rJPoGpVE/sIJq4RHYB3RztBZA0ySRMgMYZvRJ8yBiFdtrUCai4rzeafRMdsOacOE8drA9SqrNQqIkR07iCkQw0GFKkKbqmhlnZNqvfGj7wiOj6nC8x9HGTCrM5WS8MTa83xKSsRhKDR3PCqxmef1AzkhJZpUBaEjp21M1REDw7UCkhNbog77sacUvOXi+uOnF1KFRjfc2wa6pbinM0RfSI6gpCrf/YFZ/ocG1DXOhs3OXIYXS0rTRDV8yxAAWZhguYcUb8Gt+FcbhSXPl/jOlSBufdZgCJFKglr9Hf2sOvGgzVwg7Idn20hyXAWBCrmsRU2xHVsi4HZ80NtN6JXfUFsQPPJkBPWmavve22UlblMda/sQDG5b9Sugx3id+x14EzvBQGKyQEAWlUHyfa9tspKE0T1fDCgmBRlKG6n2YKruq7NslIFZ9oPChSLyHLUI0+oR8HXawJnOt/KAgHVNViFvlFsArbsfCtA80XZlqddjei5HOprq0CxEKsMoCNlpQrOtN86UCysLgPg/MMuE5RVzncCKASoygC6HtGrwHcGKBZXBKvhQWu/wqiC5HKuU0BdFt7VawWo4a/6fL8wASpA5T/pemUFvRLW1y+6fE6Aig8VH9orK5A2Qw2afNpmSBphNedC0kZY0qqtOaBpqzZpJtgc0LQns7S7bAYouooVfe6lIevqUMGw2KRl8GpAs/6BWrdwaWrtD/VMU+tMVaXtukvNnl9rbLsOqGL6bloKUy91By+cqLKDPsI5fXmtBzxBz2WbTR6uUg/S6eEqC+DZ439ES8twswDk+PifBVRKfYQ8oGorfUhXkbirgPz35RFqFuz+A8bFGiZ6p4NPAAAAAElFTkSuQmCC"
        id="image0_833_119086"
        width="84"
        height="84"
      ></image>
    </defs>
  </svg>
);
